import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CheckIcon, ClockIcon, ZapIcon } from 'lucide-react';
import { autoPrompts, triggerMeta } from '../../data/autoPrompts';
import { contactTypeMeta } from '../../data/contacts';
import { useActivityPlan } from '../../contexts/ActivityPlanContext';
import { urgencyRowClasses } from '../../utils/activityStyles';
export function AutoPromptsPanel() {
  const {
    openPromptIds,
    completePrompt,
    snoozePrompt
  } = useActivityPlan();
  const prompts = autoPrompts.filter(prompt => openPromptIds.includes(prompt.id));
  return <section aria-labelledby="prompts-heading" className="rounded-2xl border border-navy-100 bg-white shadow-card" data-id="element-29" data-mp="cgn1eul6n6v5">
      <header className="flex items-start justify-between gap-3 border-b border-navy-100 px-5 py-4" data-id="element-30" data-mp="8gkyyj7mi9et">
        <div className="flex items-start gap-2" data-id="element-31" data-mp="mfugbm7kf9kd">
          <ZapIcon className="mt-0.5 h-4 w-4 text-brand-600" aria-hidden="true" data-id="element-32" data-mp="hfzptjrpclzu" />
          <div data-id="element-33" data-mp="hdvcycbtscnf">
            <h2 id="prompts-heading" className="text-sm font-semibold text-navy-900" data-id="element-34" data-mp="3g3c8wxfkke05">
              Triggered outreach
            </h2>
            <p className="mt-0.5 text-xs text-navy-500" data-id="element-35" data-mp="3l4jfit5z7758">
              Created automatically by loan milestones and recurring cadences
            </p>
          </div>
        </div>
        <span className="inline-flex h-6 min-w-6 items-center justify-center rounded-full bg-navy-100 px-2 text-xs font-bold tabular-nums text-navy-700" data-id="element-36" data-mp="3u4okkwnp5tg8">
          {prompts.length}
        </span>
      </header>

      {prompts.length === 0 ? <div className="px-5 py-8 text-center" data-id="element-37" data-mp="cmvn1picpdw8">
          <p className="text-sm font-semibold text-navy-900" data-id="element-38" data-mp="cn5fdjqvbx53">
            Every prompt is cleared
          </p>
          <p className="mt-1 text-xs text-navy-500" data-id="element-39" data-mp="hkx464w7v352">
            New ones appear as loans move milestones or touches come due.
          </p>
        </div> : <ul className="space-y-3 p-4" data-id="element-40" data-mp="qng6mnw3bdqs">
          {prompts.map(prompt => <li key={prompt.id} className={`rounded-xl border p-4 ${urgencyRowClasses[prompt.urgency]}`} data-id="element-41" data-mp="2mp1fu7dzh8we">
              <div className="flex flex-wrap items-center gap-2" data-id="element-42" data-mp="2ipsn95uojh2f">
                <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-bold uppercase tracking-wide ring-1 ${triggerMeta[prompt.trigger].classes}`} data-id="element-43" data-mp="2wfmetvxkkffu">
                  {triggerMeta[prompt.trigger].label}
                </span>
                <span className="text-[11px] font-semibold uppercase tracking-wide text-navy-500" data-id="element-44" data-mp="31f8oxwi3pfkf">
                  {prompt.dueLabel}
                </span>
              </div>
              <p className="mt-2 text-sm font-semibold text-navy-900" data-id="element-45" data-mp="3af42g7z4pmnm">
                {prompt.title}
              </p>
              <div className="flex flex-wrap items-center gap-1.5" data-id="element-46" data-mp="1kznzjabssx66">
                <p className="text-xs font-semibold text-navy-700" data-id="element-47" data-mp="1l20lrzol9tp1">
                  {prompt.contact.name}
                </p>
                <span className={`inline-flex items-center rounded-full px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide ring-1 ${contactTypeMeta[prompt.contact.type].classes}`} data-id="element-48" data-mp="3rny3iqd8luw8">
                  {contactTypeMeta[prompt.contact.type].label}
                </span>
                <span className="text-xs text-navy-500" data-id="element-49" data-mp="3mwocpmfyclir">
                  {prompt.contact.detail}
                </span>
              </div>
              <p className="mt-0.5 text-xs text-navy-500" data-id="element-50" data-mp="3901ezhg6drbs">{prompt.context}</p>
              <p className="mt-2 rounded-lg bg-white/70 px-3 py-2 text-xs text-navy-600 ring-1 ring-navy-100" data-id="element-51" data-mp="3dymgrlb2sj2c">
                {prompt.script}
              </p>
              <div className="mt-3 flex flex-wrap items-center gap-2" data-id="element-52" data-mp="33yc17u1kizk0">
                <button type="button" onClick={() => completePrompt(prompt.id)} className="inline-flex h-10 items-center gap-1.5 rounded-lg bg-brand-600 px-3 text-sm font-semibold text-white hover:bg-brand-700" data-id="element-53" data-mp="340orqvle6i8o">
                  <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-54" data-mp="des0h25htwgq" />
                  Log it done
                </button>
                <button type="button" onClick={() => snoozePrompt(prompt.id)} className="inline-flex h-10 items-center gap-1.5 rounded-lg border border-navy-200 bg-white px-3 text-sm font-semibold text-navy-700 hover:bg-navy-50" data-id="element-55" data-mp="3ion1056ybeh">
                  <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-56" data-mp="3lwo2poty2ewp" />
                  Tomorrow
                </button>
                {prompt.linkTo ? <Link to={prompt.linkTo} className="inline-flex h-10 items-center gap-1 rounded-lg px-2 text-sm font-semibold text-brand-600 hover:underline" data-id="element-57" data-mp="3gy3762pn0jel">
                    View record
                    <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-58" data-mp="32xa7l3khay4m" />
                  </Link> : null}
              </div>
            </li>)}
        </ul>}
    </section>;
}